import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Fade, FormControl, CircularProgress } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
// import DateTimePanel from './DateTimePanel';
import Datetime from 'react-datetime';
class TimePickerPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closeVerification: false
        };
    }

    handleClose = () => {
        this.props.closePopup();
    };

    handleError = params => {
        this.setState(params);
    };
    renderButton = () => {
        const { loaderButton } = this.props;
        if (loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSave}
                >
                    Add
                </Button>
            );
        }
    };

    onSave = () => {
        this.props.saveDate();
    };
    render() {
        return (
            <div>
                <Dialog
                    maxWidth={'sm'}
                    fullWidth={true}
                    TransitionComponent={Fade}
                    className="text-center dialog-form-new dialog-form-new2"
                    open={this.props.isVisible}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <div
                        className="dialog-header"
                        style={{
                            backgroundColor: this.props.theme.palette.primary
                                .main
                        }}
                    >
                        <h3 className="dialog-heading">Select Time</h3>
                    </div>
                    <div className="dialog-body">
                        <DialogContent style={{ minHeight: '300px' }}>
                            <FormControl fullWidth>
                                <Datetime
                                    dateFormat={this.props.dateFormat}
                                    open={this.props.open}
                                    timeFormat={this.props.timeFormat}
                                    color="primary"
                                    inputProps={{
                                        placeholder: 'Click here to choose'
                                    }}
                                    value={this.props.value}
                                    onChange={this.props.onChangeDate}
                                    defaultValue={this.props.defaultValue}
                                />
                            </FormControl>
                        </DialogContent>
                        <DialogActions>{this.renderButton()}</DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(TimePickerPopup);



// WEBPACK FOOTER //
// ./src/components/Providers/TimePickerPopup.js